import { TranslationKeys } from 'locales/translationKeys'
import { StaticImageData } from 'next/image'
import meatCloseUp from '../../../../../public/assets/home/meat-close-up-2.webp'
import newyorkStrip from '../../../../../public/assets/home/new-york-strips.webp'
import minimalProcess from '../../../../../public/assets/home/minimally-processed.webp'

type Feature = {
  label: TranslationKeys
  description: TranslationKeys
  infoCard?: {
    heading: TranslationKeys
    body: TranslationKeys
    image: StaticImageData
    imageAlt: TranslationKeys
  }
}

export const features: Feature[] = [
  {
    label: 'home:live-better.features.0.label',
    description: 'home:live-better.features.0.description',
    infoCard: {
      heading: 'home:live-better.features.0.info-card.heading',
      body: 'home:live-better.features.0.info-card.body',
      image: newyorkStrip,
      imageAlt: 'home:live-better.features.0.info-card.imageAlt',
    },
  },
  {
    label: 'home:live-better.features.1.label',
    description: 'home:live-better.features.1.description',
    infoCard: {
      heading: 'home:live-better.features.1.info-card.heading',
      body: 'home:live-better.features.1.info-card.body',
      image: meatCloseUp,
      imageAlt: 'home:live-better.features.1.info-card.imageAlt',
    },
  },
  {
    label: 'home:live-better.features.2.label',
    description: 'home:live-better.features.2.description',
    infoCard: {
      heading: 'home:live-better.features.2.info-card.heading',
      body: 'home:live-better.features.2.info-card.body',
      image: minimalProcess,
      imageAlt: 'home:live-better.features.2.info-card.imageAlt',
    },
  },
  {
    label: 'home:live-better.features.3.label',
    description: 'home:live-better.features.3.description',
  },
]
